import * as actionTypes from './actionTypes';

export const setWPMHistogramData = (data) => ({
  type: actionTypes.SET_WPM_HISTOGRAM_DATA,
  data
});